import api from './api';

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export interface User {
  id: number;
  name: string;
  email: string;
  team_id?: number | null;
  phone?: string;
  department?: string;
  position?: string;
  status?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateUserData {
  name: string;
  email: string;
  password: string;
  team_id?: number | null;
  phone?: string;
  department?: string;
  position?: string;
  status?: string;
}

export const userService = {
  async getAll(): Promise<User[]> {
    const response = await api.get('/users');
    return unwrap<User[]>(response);
  },

  async getById(id: number): Promise<User> {
    const response = await api.get(`/users/${id}`);
    return unwrap<User>(response);
  },

  async create(data: CreateUserData): Promise<User> {
    const response = await api.post('/users', data);
    return unwrap<User>(response);
  },

  async update(id: number, data: Partial<CreateUserData>): Promise<User> {
    const response = await api.put(`/users/${id}`, data);
    return unwrap<User>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/users/${id}`);
  },
};
